<template>
    <my-dialog title="会员卡充值记录确认" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <detail ref="detail"></detail>
        <div class="item_info">
            <el-descriptions class="margin-top" title="提成信息" :column="5" border>
                <el-descriptions-item span="3">
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        充卡提成员工
                    </template>
                    <el-select name="employeeKeyIds" v-model="commissionInfo.employeeKeyIds" multiple
                        placeholder="请选择员工" style="width: 100%;" filterable clearable>
                        <el-option v-for="item in employeeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId" />
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-cherry"></i>
                        是否电话提成
                    </template>
                    <el-switch v-model="commissionInfo.isPhoneBonus" :active-value="true" :inactive-value="false"
                        active-text="是" inactive-text="否" />
                </el-descriptions-item>
                <el-descriptions-item v-if="commissionInfo.isPhoneBonus">
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        电话提成员工
                    </template>
                    <el-select name="phoneEmlpoyeeKeyIds" v-model="commissionInfo.phoneEmlpoyeeKeyIds" placeholder="请选择员工"
                        style="width: 100%;" filterable clearable multiple>
                        <el-option v-for="item in phoneEmployeeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId" />
                    </el-select>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
            <el-button type="primary" size="small" @click="handleConfirm">确认充值</el-button>
        </div>
    </my-dialog>
</template>
<script>
import {
    ConfirmVipRecharge
} from "@/api/vipApi.js";
import detail from "./detail.vue";
import {
    GetUserBindSelectByPermission
} from "@/api/userApi.js";
export default {
    props: [],
    data() {
        return {
            showDialog: false,
            employeeList: [],
            phoneEmployeeList: [],
            commissionInfo: {
                employeeKeyIds: [],
                keyId: "",
                isPhoneBonus: false,
                phoneEmlpoyeeKeyIds: [],
            },
            storeKeyId: "",
        };
    },
    components: {
        detail,
    },
    created() { },
    methods: {
        getConfirmDialog(row) {
            this.commissionInfo.isPhoneBonus = false;
            this.commissionInfo.phoneEmlpoyeeKeyId = "";
            this.commissionInfo.employeeKeyIds = [];
            this.commissionInfo.phoneEmlpoyeeKeyIds = [];
            this.commissionInfo.keyId = row.keyId;
            this.storeKeyId = row.storeKeyId;
            this.$nextTick(() => {
                this.$refs.detail.getDetail(row);
            })
            // 获取员工列表
            this.getEmployeeList();
            this.showDialog = true;
        },
        // 关闭
        closeDialog() {
            this.commissionInfo.isPhoneBonus = false;
            this.commissionInfo.phoneEmlpoyeeKeyId = "";
            this.commissionInfo.employeeKeyIds = [];
            this.commissionInfo.phoneEmlpoyeeKeyIds = [];
            this.commissionInfo.keyId = "";
            this.showDialog = false;
        },
        // 确认充值
        handleConfirm() {
            if (this.commissionInfo.employeeKeyIds == null || this.commissionInfo.employeeKeyIds == undefined || this.commissionInfo.employeeKeyIds.length == 0) {
                this.$message({
                    type: "error",
                    message: "请选择充卡提成员工！",
                });
                return;
            }
            if (this.commissionInfo.isPhoneBonus) {
                if (this.commissionInfo.phoneEmlpoyeeKeyIds == null || this.commissionInfo.phoneEmlpoyeeKeyIds == undefined || this.commissionInfo.phoneEmlpoyeeKeyIds.length == 0) {
                    this.$message({
                        type: "error",
                        message: "请选择电话提成员工！",
                    });
                    return;
                }
            }
            this.$confirm('确定确认这个充值记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ConfirmVipRecharge(this.commissionInfo)
                    .then((res) => {
                        if (res.code == 1) {
                            this.$message({
                                type: "success",
                                message: "确认充值成功！",
                            });
                            setTimeout(() => {
                                this.$parent.getListData();
                                this.showDialog = false;
                            }, 1500);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("确认充值失败，请稍后再试！");
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消确认充值",
                });
            });
        },
        // 获取员工列表
        getEmployeeList() {
            GetUserBindSelectByPermission({
                keyId: this.storeKeyId,
                isChargePerson: true,
            }).then((res) => {
                if (res.code == 1) {
                    this.employeeList = res.data;
                    this.phoneEmployeeList = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
    },
};
</script>
<style scoped lang="scss">
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.border_Danger {
    border-left: 5px solid #ff0000;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .btnDiv {
        display: block;
        unicode-bidi: isolate;
        word-break: break-all;
    }

    .btnDivItem {
        display: inline-block;
    }

    .text-red {
        display: block;
        background-color: #ff0000;
    }
}
</style>